import { useEffect, useState } from 'react';

import useMedia from '~hooks/useMedia';

import * as S from './style';

export default function GuideMessage() {
  const { isMobile } = useMedia();
  const [isEntered, setIsEntered] = useState<boolean>();

  useEffect(() => {
    setTimeout(() => {
      setIsEntered(true);
    }, 150);
  }, []);

  return (
    // FIXME: Sales Guide message랑 통일
    <S.Wrapper isEntered={isEntered}>
      <>
        {`${isMobile ? '손가락' : '마우스'}를 올려`}
        <br />
        상세 정보를 확인해 보세요.
      </>
    </S.Wrapper>
  );
}
